export enum RouteKeys {
  List = '/reported-ads',
  Details = '/reported-ads/:id',
}
